/**
 * Rules about a job's visits (M2-52) that more than one screen enforces — the
 * job page's Visits section and the dispatch board's move dialog. One copy,
 * because two drift, and a board that offers what the job page hides (or what
 * the API refuses) is worse than either on its own.
 */

/** Someone is driving there or working it (the API's "A job that is {Status} cannot be unscheduled."). */
export const UNDERWAY_STATUSES: readonly string[] = ['EnRoute', 'InProgress'];

/**
 * Whether one of a job's visits may be taken off: any visit, except the LAST
 * one of a job that is underway — that is a cancellation, not a schedule
 * change, and the API refuses it (`JobVisitEndpoints`, `/schedule`).
 */
export function canRemoveVisit(visitCount: number, status: string): boolean {
  return !(visitCount === 1 && UNDERWAY_STATUSES.includes(status));
}

/**
 * Work that is done (the API's `IsFinished`): its time and its people no longer
 * move, and there is no appointment left to email anyone about — so no screen
 * offers "on my way" on it (M2-21). Any other status the API's
 * `AppointmentEmail.IsLive` rejects is shown disabled, with the API's sentence.
 */
export const FINISHED_STATUSES: readonly string[] = ['Complete', 'Invoiced', 'Closed', 'Canceled'];
